import fetch from "@lib/fetch";
import { API } from "../../config";

export const createToken = (token, name, type, environment) => {
    return fetch(`${API}/v1/keys`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({name,type,environment})
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
};

export const getTokens = (token,env) => {
    return fetch(`${API}/v1/keys?environment=${env}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
};

export const deleteTokens = (token,keyId) => {
    return fetch(`${API}/v1/keys/${keyId}`,{
        mode: 'cors',
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        });
};

export const getIntegrations = (token) => {
    return fetch(`${API}/v1/integrations`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
}

export const deleteIntegrations = (token,keyId) => {
    return fetch(`${API}/v1/integrations`,{
        mode: 'cors',
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        });
};

export const fetchKeyPaymentData = async (token, keyId, type ) => {
    return fetch(`${API}/v1/keys/${keyId}/qris_payment`,{
      mode: 'cors',
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
}

export const extendKey = async (token, keyId) => {
    return fetch(`${API}/v1/keys/${keyId}/extend`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
}